import { Documentos } from "./documentos";

export class Acompanhamento {
  inscricao : string ='';
  cpf : string = '';
  nome : string = '';
  rg : string = '';
  rgOrgao : string = '';
  rguf : string = '';
  numOAB : string = '';
  orgaoExpOAB : string = '';
  sexo : string = '';
  escrita : string ='';
  telefoneResidencial : string='';
  telefoneComercial : string='';
  telefoneCelular : string='';
  email : string = '';
  situacao : string = '';
  dataDivulgacao : string ='';
  horaDivulgacao : string = '';
  existeAlocacao : string ='';
  alocado : boolean = false;
  sala : string = '';
  andar : string='';
  descricaoSala : string='';
  dataProva : string='';
  horaInicioProva : string = '';
  horaFimProva : string ='';
  instituicao : string = '';
  endereco : string='';
  autorizaSMS : boolean = false;
  autorizaInfoPos : boolean = false;
  deficiencia : string = '';
  descricaoDeficiencia : string='';
  apoio : string = '';
  necessitaApoio : string = '';
  indCotista : boolean = false;
  indIsentoTaxa : boolean = false;
  descricaoTipoCotista : string = ''
  liberarMatricula : boolean = false;
  boletoVencido : boolean=false;
  exibeBotaoBoleto : boolean = false;
  urlPreMatricula : string='';
  documentos: Array<Documentos> = [];
  isIsentoIrpf : boolean = false;
  isDesempregado : boolean = false;
  indVista : boolean = false;
}
